"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientOrderList = void 0;
const Base_1 = require("./Base");
exports.GetClientOrderList = {
    url: Base_1.URL_BASE + "/GetClientOrderList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientOrderList.js.map